import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class UserService {
    getAllUser() {
        return axios.get(API_URL+'user', { headers: authHeader() });
    }
    addUser(data) {
        return axios.post(API_URL + 'user', data, {
            headers: authHeader() });
    }
    updateUser(id, data){
        return axios.patch(API_URL + 'user/'+id, data, {
            headers: authHeader() });
    }
    detailUser(id){
        return axios.get(API_URL + 'user/'+id, {
            headers: authHeader() });
    }
    deleteUser(id){
        return axios.delete(API_URL + 'user/'+id, {
            headers: authHeader() });
    }
    logOut(){
        return axios.get(API_URL + 'auth/logout/', {
            headers: authHeader() });
    }
    resetPassword(id, data) {
        return axios.post(API_URL+'user/reset-password/'+id, data, { headers: authHeader() });
    }

    profileUser() {
        return axios.get(API_URL+'profile/user', { headers: authHeader() });
    }
    changeProfile(data) {
        return axios.patch(API_URL+'profile/change-profile', data, { headers: authHeader() });
    }
    changePassword(data) {
        return axios.post(API_URL+'profile/change-password', data, { headers: authHeader() });
    }
    changeAvatar(data) {
        return axios.post(API_URL+'profile/change-avatar', data, { headers: authHeader() });
    }
}

export default new UserService();
